import React from 'react';
export function PainPointsSection() {
  const points = [{
    emoji: '😰',
    text: 'Du kommst in die Stunde, ohne genau zu wissen, was du geben sollst'
  }, {
    emoji: '⏱️',
    text: 'Du verbringst Stunden mit Planung, die du in Minuten lösen könntest'
  }, {
    emoji: '🤷',
    text: 'Du weißt nicht, wie du Philosophie einbaust, ohne gezwungen zu klingen'
  }, {
    emoji: '💸',
    text: 'Du verlangst weniger, als du verdienst, weil du dich nicht zu positionieren weißt'
  }, {
    emoji: '😓',
    text: 'Deine Schülerinnen machen immer dasselbe und deine Stunden wachsen nicht'
  }];
  return <section className="bg-brand-creamDark px-4 py-20" data-id="element-100">
      <div className="mx-auto max-w-3xl text-center" data-id="element-101">
        <h2 className="mb-4 text-3xl font-black text-brand-text md:text-4xl" data-id="element-102">
          👉 Erkennst du dich in diesen Szenen wieder?
        </h2>
        <p className="mb-12 text-brand-gray" data-id="element-103">
          Wenn du bei einer mit Ja antwortest — ist dieses Kit für dich
        </p>

        <div className="mb-12 space-y-4 text-left" data-id="element-104">
          {points.map(point => <div key={point.text} className="flex items-center gap-4 rounded-2xl border border-white/60 bg-white p-5 shadow-sm md:p-6" data-id="element-105">
              <span className="shrink-0 text-3xl" aria-hidden="true" data-id="element-106">
                {point.emoji}
              </span>
              <span className="text-base font-medium text-brand-text md:text-lg" data-id="element-107">
                {point.text}
              </span>
            </div>)}
        </div>

        <p className="font-serif text-xl font-bold italic text-brand-green md:text-2xl" data-id="element-108">
          Und du verdienst viel mehr als das →
        </p>
      </div>
    </section>;
}